module.exports = __webpack_public_path__ + "static/media/IMG_1228.6d53c44d.jpg";